import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/functions";

var firebaseConfig = {
  apiKey: "AIzaSyBrVR9LRLUebteng1TVDRULle_2ZjwX_xw",
  authDomain: "test-shop-d4ff4.firebaseapp.com",
  projectId: "test-shop-d4ff4",
  storageBucket: "test-shop-d4ff4.appspot.com",
  messagingSenderId: "23122358083",
  appId: "1:23122358083:web:a663ab99efaecf89f209f6",
  measurementId: "G-CF91J92YV8"
};
firebase.initializeApp(firebaseConfig);

export default firebase;
